import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BooleanStateService implements OnDestroy {

  public stateSource: BehaviorSubject<boolean>;

  constructor() {
    this.stateSource = new BehaviorSubject(false);
  }

  public start(): void {
    this.stateSource.next(true);
  }

  public stop(): void {
    this.stateSource.next(false);
  }

  public complete(): void {
    this.stateSource.next(false);
  }

  public ngOnDestroy(): void {
    this.complete();
    this.stateSource.complete();
  }
}
